import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import countrycode from "../../data/countrycode.json";
import { useDispatch, useSelector } from "react-redux";
import {
    hotelsearchquery,
    fetchhotelresult,
    clearHotelData,
    selectHotelQuery
} from './HotelSlice';

import ReactRangeSliderInput from 'react-range-slider-input';
import CurFt from '../../components/CurFt';
import { toast } from 'react-hot-toast';
import moment from 'moment/moment';
import HotelSearchForm from './HotelSearchForm';

const HotelSearchResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [priceRange, setPriceRange] = useState([0, 0]);
    const [selectedMeals, setSelectedMeals] = useState([]);
    const [selectedHotelLocation, setSelectedHotelLocation] = useState([]);
    const [selectedHotelProType, setSelectedHotelProType] = useState([]);
    const [selectedStars, setSelectedStars] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchData, setSearchData] = useState(null);
    const [apiData, setApiData] = useState(null);
    const [loading, setloading] = useState(true);
    const [showModifyForm, setShowModifyForm] = useState(false);
    const [modifyFormData, setModifyFormData] = useState(null);
    const [showCityModal, setShowCityModal] = useState(false);
    const dispatch = useDispatch();

    const HotelQuery = useSelector(selectHotelQuery);
    // Nationality dropdown states
    const [hotelDataFull, setHotelDataFull] = useState([]);
    const [hotelData, setHotelData] = useState([]);
    const [hotelDataFiltered, setHotelDataFiltered] = useState([]);
    const [PriceRangeRound, setPriceRangeRound] = useState([0, 0]);






    const [filthotelMeal, setFilthotelMeal] = useState([]);
    const [filthotelLoc, setFilthotelLoc] = useState([]);
    const [filthotelProperty, setFilthotelProperty] = useState([]);
    const [filthotelStars, setFilthotelStars] = useState([]);
    const [MinPriceRange, setMinPriceRange] = useState(0);
    const [MaxPriceRange, setMaxPriceRange] = useState(0);


    const [allNationalities] = useState(countrycode);



    const [visibleCount, setVisibleCount] = useState(20);
    const [isLoadingMore, setIsLoadingMore] = useState(false);




    const SearchHotelQuery = async (payload) => {
        try {
            dispatch(clearHotelData())
            const response = await dispatch(hotelsearchquery(payload)).unwrap();
            if (!response?.data?.status?.success) {
                toast.error(response?.data?.message, { autoClose: 3000 });
                navigate(`/hotel`);
            }
        } catch (err) {
            console.error("Hotel search or fetch result failed:", err);
        }
    };
    useEffect(() => {

        if (HotelQuery?.resultSet?.length) {
            const currency = {
                CurrencyRate: "1",
                CurrencyTitle: process.env.REACT_APP_DEFAULT_CURRENCY || "INR",
                CurrencyId: 1,
            };
            let searchIDS = HotelQuery?.resultSet;
            let index = 0;
            setHotelDataFull([])
            setHotelData([])
            const fetchData = async () => {
                setloading(true);
                const totalIds = HotelQuery.resultSet.length;
                let completedCount = 0;
                let hasDataLoaded = false;

                const fetchOne = async (searchId) => {
                    try {
                        const response = await dispatch(
                            fetchhotelresult({ searchId, currency, index, searchIDS })
                        ).unwrap();
                        localStorage.removeItem('ItineraryInfo');
                        const { data } = response;

                        if (data?.status?.success) {
                            let hotelsdata = data.resultSet?.result;
                            if (searchData?.selectedRatings?.length > 0 && hotelsdata.length > 0) {
                                hotelsdata = hotelsdata.filter(hotel =>
                                    searchData.selectedRatings.includes(hotel.rt)
                                );
                            }
                            // If this id came back with no hotels, skip it silently and
                            // let the other ids keep loading instead of blocking on it.
                            if (hotelsdata && hotelsdata.length > 0) {
                                setHotelDataFull(prev => prev.concat(hotelsdata));

                                setHotelData(prev => prev.concat(hotelsdata));

                                const hotelMeal = data.resultSet.hotelMeal || [];
                                const hotelProperty = data.resultSet.hotelProperty || [];
                                const hotelStars = (data.resultSet.hotelStars || []).filter(star => star > 0);
                                const location = data.resultSet.location || {};

                                // Derive the price range from the SAME field used in applyFilters
                                // (HotelRoomPrice), not the raw `price`/PriceRange from the API —
                                // those exclude agent markup and can end up lower than
                                // HotelRoomPrice, causing hotels to be filtered out immediately.
                                const roomPrices = hotelsdata
                                    .map(h => h?.pops?.[0]?.HotelRoomPrice)
                                    .filter(p => typeof p === 'number' && !isNaN(p));

                                // Merge filter options across ids instead of overwriting them,
                                // since results now arrive out of order.
                                setFilthotelMeal(prev => Array.from(new Set([...(prev || []), ...hotelMeal])));
                                setFilthotelProperty(prev => Array.from(new Set([...(prev || []), ...hotelProperty])));
                                setFilthotelStars(prev => Array.from(new Set([...(prev || []), ...hotelStars])));
                                setFilthotelLoc(prev => {
                                    const merged = { ...(prev || {}) };
                                    Object.entries(location).forEach(([loc, count]) => {
                                        merged[loc] = (merged[loc] || 0) + count;
                                    });
                                    return merged;
                                });

                                if (roomPrices.length > 0) {
                                    const minRoomPrice = Math.min(...roomPrices);
                                    const maxRoomPrice = Math.max(...roomPrices);

                                    setMinPriceRange(prev => (prev ? Math.min(prev, minRoomPrice) : minRoomPrice));
                                    setMaxPriceRange(prev => (prev ? Math.max(prev, maxRoomPrice) : maxRoomPrice));
                                    setPriceRange(prev => [
                                        prev[0] ? Math.min(prev[0], minRoomPrice) : minRoomPrice,
                                        prev[1] ? Math.max(prev[1], maxRoomPrice) : maxRoomPrice,
                                    ]);
                                    if (searchData?.routeType == '2') {
                                        setPriceRangeRound(prev => [
                                            prev[0] ? Math.min(prev[0], minRoomPrice) : minRoomPrice,
                                            prev[1] ? Math.max(prev[1], maxRoomPrice) : maxRoomPrice,
                                        ]);
                                    }
                                }

                                // Reveal the results as soon as the first id with data
                                // comes back, instead of waiting for every id to finish.
                                hasDataLoaded = true;
                                setloading(false);
                            }
                        }
                    } catch (error) {
                        console.error(`Error fetching hotel result for searchId ${searchId}:`, error);
                    } finally {
                        completedCount += 1;
                        if (completedCount === totalIds && !hasDataLoaded) {
                            // Every id has finished and none returned data — stop the
                            // skeleton so the empty state can render.
                            setloading(false);
                        }
                    }
                };

                // Fire every searchId in parallel rather than awaiting them one by
                // one, so a slow id can't hold up the ones that already have data.
                await Promise.allSettled(
                    HotelQuery.resultSet.map(searchId => fetchOne(searchId))
                );
            }
            fetchData();

        }
    }, [HotelQuery]);
    useEffect(() => {
        const parsedData = parseSearchParams();
        console.log(parsedData);

        setSearchData(parsedData);
        setModifyFormData(parsedData);
        const generatedApiData = generateAPIDataFromParams(parsedData);
        setApiData(generatedApiData);
        SearchHotelQuery(generatedApiData)

    }, [location.search]);

    const priceRangeFilter = (event) => {
        setPriceRange([event[0], event[1]])
    }
    const toggleMealOption = (meal) => {
        if (selectedMeals.includes(meal)) {
            setSelectedMeals(selectedMeals.filter(m => m !== meal));
        } else {
            setSelectedMeals([...selectedMeals, meal]);
        }
    };
    const handleSelectedStars = (meal) => {
        if (selectedStars.includes(meal)) {
            setSelectedStars(selectedStars.filter(m => m !== meal));
        } else {
            setSelectedStars([...selectedStars, meal]);
        }
    };
    const handleselectedHotelLocation = (hotel) => {
        if (selectedHotelLocation.includes(hotel)) {
            setSelectedHotelLocation(selectedHotelLocation.filter(m => m !== hotel));
        } else {
            setSelectedHotelLocation([...selectedHotelLocation, hotel]);
        }
    };
    const handleselectedHotelProType = (hotel) => {
        if (selectedHotelProType.includes(hotel)) {
            setSelectedHotelProType(selectedHotelProType.filter(m => m !== hotel));
        } else {
            setSelectedHotelProType([...selectedHotelProType, hotel]);
        }
    };
    const [sort, setSort] = useState("recommended");
    const SORT_OPTIONS = [
        { value: "recommended", label: "Recommended" },
        { value: "price_asc", label: "Price: Low to High" },
        { value: "price_desc", label: "Price: High to Low" },
        { value: "rating_desc", label: "Star Rating: High to Low" },
    ];
    const [SearchByHotel, setSearchByHotel] = useState([]);
    const searchByHotel = (event) => {
        const { value } = event.target;
        const searchTerm = value.trim().toLowerCase();

        if (searchTerm !== '') {
            const filteredList = hotelDataFull.filter(f => {
                const hotelName = f.name ? f.name.toLowerCase() : '';
                const hotelLocation = f.loc ? f.loc.toLowerCase() : '';

                return hotelName.includes(searchTerm) || hotelLocation.includes(searchTerm);
            });

            setHotelDataFiltered(filteredList);
        } else {
            setHotelDataFiltered([]);
        }
        applyFilters();
    };
    const applyFilters = () => {
        let updatedList
        if (hotelDataFiltered && hotelDataFiltered.length > 0) {
            updatedList = hotelDataFiltered
        } else {
            updatedList = hotelDataFull
        }

        if (selectedMeals.length) {
            updatedList = updatedList.filter(f => selectedMeals.includes(f.MealPlan))
        }

        if (priceRange[0] > 0 && priceRange[1] > 0) {
            updatedList = updatedList.filter(f => parseFloat(priceRange[0] - 1) <= f.pops[0].HotelRoomPrice && parseFloat(priceRange[1] + 1) >= f.pops[0].HotelRoomPrice)
        }

        if (selectedHotelLocation.length) {
            updatedList = updatedList.filter(f => selectedHotelLocation.includes(f.loc))
        }
        if (selectedHotelProType.length) {
            updatedList = updatedList.filter(f => selectedHotelProType.includes(f.pt))
        }

        if (selectedStars.length) {
            updatedList = updatedList.filter(f => selectedStars.includes(f.rt))
        }
        if (sort === 'price_asc') {
            updatedList.sort((a, b) => a.price - b.price);
        } else if (sort === 'price_desc') {
            updatedList.sort((a, b) => b.price - a.price);
        } else if (sort === 'rating_desc') {
            updatedList.sort((a, b) => a.rt - b.rt);
        } else {
            updatedList.sort((a, b) => b.price - a.price);
        }

        if (updatedList) {
            setHotelData([...updatedList.slice(0, visibleCount)])
        }

    }

    useEffect(() => {
        applyFilters();
    }, [selectedMeals, selectedHotelLocation, sort, selectedHotelProType, priceRange, selectedStars, visibleCount, SearchByHotel, hotelDataFiltered])

    const handleScroll = useCallback(() => {
        if (isLoadingMore) return;

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // Load more when user is 100px from bottom
        if (scrollTop + windowHeight >= documentHeight - 100) {
            if (visibleCount < hotelDataFull.length) {
                setIsLoadingMore(true);
                // Add a small delay to show loading state
                setTimeout(() => {
                    setVisibleCount(prevCount => prevCount + 20);
                    setIsLoadingMore(false);
                }, 300);
            }
        }
    }, [visibleCount, hotelDataFull && hotelDataFull.length, isLoadingMore]);

    // Add scroll event listener
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    useEffect(() => {
        setVisibleCount(20);
    }, [selectedMeals, selectedHotelLocation, priceRange, selectedStars, hotelDataFull]);

    const parseSearchParams = () => {
        const searchParams = new URLSearchParams(location.search);

        const formatDisplayDate = (dateString) => {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            if (!dateString) return '';
            const [year, month, day] = dateString.split('-');
            return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
        };

        // Get nationality name from code
        const nationalityCode = searchParams.get('nationality') || '106';
        const nationality = allNationalities.find(n => n.code === nationalityCode)?.name || 'India';
        const parsedData = {
            city: decodeURIComponent(searchParams.get('cityname') || ''),
            cityCode: searchParams.get('cityId') || '',
            checkIn: formatDisplayDate(searchParams.get('checkin_date') || ''),
            checkOut: formatDisplayDate(searchParams.get('checkout_date') || ''),
            nationality: nationality,
            interNationalSearch: searchParams.get('interNationalSearch'),
            nationalityCode: nationalityCode,
            hotel_countryCode: searchParams.countryName,
            selectedRatings: searchParams.get('hotelRating') ?
                searchParams.get('hotelRating').split(',').map(Number).filter(r => !isNaN(r)) : [],
            rooms: [],
            guestSummary: searchParams.get('guest') || '',
            totalAdults: parseInt(searchParams.get('adults') || '0'),
            totalChildren: parseInt(searchParams.get('childs') || '0'),
            is_city: searchParams.get('is_city') || '1',
            hotel_id: searchParams.get('hotel_id') || 0,
            HomeStayOnly: searchParams.get('HomeStayOnly') || false
        };


        // Parse room data dynamically from URL
        const roomCount = parseInt(searchParams.get('rooms') || '1');
        for (let i = 1; i <= roomCount; i++) {
            const adults = parseInt(searchParams.get(`room${i}_adults`) || '1');
            const children = parseInt(searchParams.get(`room${i}_children`) || '0');
            const childAge = [];

            for (let j = 1; j <= children; j++) {
                const age = searchParams.get(`room${i}_child${j}_age`);
                if (age && age !== '') {
                    childAge.push(parseInt(age));
                }
            }

            parsedData.rooms.push({
                adults: adults,
                children: children,
                childAge: childAge
            });
        }

        return parsedData;
    };

    const generateAPIDataFromParams = (parsedData) => {
        const formatAPIDate = (dateString) => {
            const months = {
                'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
                'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
                'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
            };

            if (!dateString) return '';
            const parts = dateString.split(' ');
            const day = parts[0].padStart(2, '0');
            const month = months[parts[1]];
            const year = parts[2];

            return `${year}-${month}-${day}`;
        };
        const agent_markup = JSON.parse(localStorage.getItem('agent_markup') || "[]");
        let match = {};
        if (parsedData.interNationalSearch === true || parsedData.interNationalSearch === "true") {
            match = agent_markup?.find(
                item => item.api_source_id === 2 && item.type === 1
            );
        } else {
            match = agent_markup?.find(
                item => item.api_source_id === 2 && item.type === 0
            );
        }
        return {
            interNationalSearch: parsedData.interNationalSearch === true || parsedData.interNationalSearch === "true"
            ,
            isMobileSearch: false,
            agent_markup: match?.markup || 0,
            HomeStayOnly: parsedData?.HomeStayOnly || false,
            assignTo: "self",
            JourneyType: 0,
            TPSystemID: 0,
            APIData: {
                searchQuery: {
                    checkinDate: formatAPIDate(parsedData.checkIn),
                    checkoutDate: formatAPIDate(parsedData.checkOut),
                    roomInfo: parsedData.rooms.map(room => ({
                        numberOfAdults: room.adults,
                        numberOfChild: room.children,
                        childAge: room.childAge.map(age => age.toString())
                    })),
                    searchCriteria: {
                        city: parsedData.city,
                        currency: "INR",
                        nationality: parsedData.nationalityCode
                    },
                    searchPreferences: {
                        ratings: parsedData.selectedRatings,
                        fsc: true
                    }
                },
                is_city: parsedData.is_city === "1" || parsedData.is_city === 1,
                city: parsedData.city,
                hotel_id: parsedData?.hotel_id ?? 0,
                sync: true
            }
        };
    };
    // City selection handler
    const handleShowCity = () => {
        setShowCityModal(true);
    };

    const handleviewRoom = (e) => {
        const HotelID = e.id
        const BookingID = e.searchId

        const checkIn = moment(searchData.checkIn).format("YYYY-MM-DD");
        const checkOut = moment(searchData.checkOut).format("YYYY-MM-DD");

        const params = new URLSearchParams({
            checkIn,
            checkOut,
            currency: "INR", // or searchData.currency if available
            nationality: searchData.nationalityCode,
            rooms: JSON.stringify(searchData.rooms),
        });

        // window.location.href = `/hotel/details/${BookingID}/${HotelID}`;
        const url = `/hotel/details/${BookingID}/${HotelID}?${params.toString()}`;
        window.open(url, '_blank');

    }




    const StarRating = ({ rating }) => {
        if (!rating) return null;

        return (
            <div className="flex">
                {[...Array(5)].map((_, i) => (
                    <svg key={i} className={`w-4 h-4 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                ))}
            </div>
        );
    };



    // Show loading state while parsing data
    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                {/* <div className="text-xl">Loading search results...</div> */}
                <div className="flex gap-4 w-full">
                    {/* Left Filter Skeleton */}
                    <div className="w-1/4 bg-white rounded-2xl p-5 shadow">
                        <div className="h-6 w-32 bg-gray-200 rounded mb-4 animate-pulse" />
                        <div className="h-5 w-24 bg-gray-200 rounded mb-6 animate-pulse" />

                        {/* Price range */}
                        <div className="space-y-4 mb-6">
                            <div className="h-3 bg-gray-200 rounded w-3/4 animate-pulse" />
                            <div className="h-3 bg-gray-200 rounded w-1/2 animate-pulse" />
                        </div>

                        {/* Meal Option */}
                        <div className="h-5 w-20 bg-gray-200 rounded mb-2 animate-pulse" />
                        <div className="h-4 w-24 bg-gray-200 rounded mb-6 animate-pulse" />

                        {/* Star Ratings */}
                        <div className="h-5 w-28 bg-gray-200 rounded mb-3 animate-pulse" />
                        {[...Array(3)].map((_, i) => (
                            <div key={i} className="flex items-center space-x-2 mb-2">
                                <div className="h-4 w-4 bg-gray-200 rounded animate-pulse" />
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        ))}

                        {/* Hotel Location */}
                        <div className="h-5 w-32 bg-gray-200 rounded mt-4 mb-3 animate-pulse" />
                        {[...Array(2)].map((_, i) => (
                            <div key={i} className="flex items-center space-x-2 mb-2">
                                <div className="h-4 w-4 bg-gray-200 rounded animate-pulse" />
                                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        ))}
                    </div>

                    {/* Right Hotel Cards Skeleton */}
                    <div className="flex flex-col gap-6 w-3/4">
                        {[...Array(3)].map((_, i) => (
                            <div
                                key={i}
                                className="flex bg-white rounded-2xl shadow overflow-hidden animate-pulse"
                            >
                                {/* Hotel Image */}
                                <div className="w-48 h-40 bg-gray-200" />

                                {/* Hotel Info */}
                                <div className="flex-1 p-2 space-y-3">
                                    <div className="h-5 bg-gray-200 rounded w-1/3" />
                                    <div className="h-4 bg-gray-200 rounded w-1/4" />
                                    <div className="h-4 bg-gray-200 rounded w-2/3" />
                                    <div className="h-4 bg-gray-200 rounded w-1/3" />
                                    <div className="h-6 bg-gray-200 rounded w-24 mt-2" />
                                </div>

                                {/* Price + Button */}
                                <div className="w-48 p-5 flex flex-col justify-center items-end space-y-3">
                                    <div className="h-6 bg-gray-200 rounded w-28" />
                                    <div className="h-4 bg-gray-200 rounded w-20" />
                                    <div className="h-10 bg-gray-200 rounded w-32" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (!searchData || !modifyFormData) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-xl text-red-600">No search data found</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <header className="bg-white shadow-sm">
                <div className="border-b border-gray-200">
                    <div className="container mx-auto px-4 py-3 flex justify-between items-center">
                        <div className="text-blue-600 font-bold text-xl">{modifyFormData.city || ''}</div>
                        <div className="flex space-x-4">
                            <button
                                onClick={() => setShowModifyForm(!showModifyForm)}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-medium transition-colors"
                            >
                                {showModifyForm ? 'Cancel Modify' : 'Modify Search'}
                            </button>
                            {/* <div className="flex space-x-4 text-sm">
                                <button className="text-gray-600 hover:text-blue-600">check-in</button>
                                <button className="text-gray-600 hover:text-blue-600">check-out</button>
                            </div> */}
                        </div>
                    </div>
                </div>

                {/* Modify Search Form */}
                {showModifyForm && modifyFormData && (
                    <div className="container mx-auto px-4 py-6 bg-blue-50 border-t border-blue-200">
                        <h3 className="text-lg font-semibold mb-4 text-slate-800">Modify Your Search</h3>
                        <HotelSearchForm initialFormData={modifyFormData} />
                    </div>
                )}

                {/* Current Search Summary */}
                {!showModifyForm && (
                    <>
                        <div className="container mx-auto px-4 py-4">
                            <div className="flex flex-wrap gap-4">
                                <div className="flex flex-col">
                                    <label className="text-xs text-gray-500 mb-1">Check-in</label>
                                    <div className="border border-gray-300 rounded px-3 py-2 text-sm">
                                        {searchData.checkIn}
                                    </div>
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-xs text-gray-500 mb-1">Check-out</label>
                                    <div className="border border-gray-300 rounded px-3 py-2 text-sm">
                                        {searchData.checkOut}
                                    </div>
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-xs text-gray-500 mb-1">Rooms/Guests</label>
                                    <div className="border border-gray-300 rounded px-3 py-2 text-sm">
                                        {searchData.rooms.length} Room{searchData.rooms.length > 1 ? 's' : ''} | {searchData.totalAdults + searchData.totalChildren} Guest{searchData.totalAdults + searchData.totalChildren > 1 ? 's' : ''}
                                    </div>
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-xs text-gray-500 mb-1">Nationality</label>
                                    <div className="border border-gray-300 rounded px-3 py-2 text-sm">
                                        {searchData.nationality}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Location & Breadcrumb */}
                        <div className="bg-gray-50 border-t border-gray-200">
                            <div className="container mx-auto px-4 py-2 flex items-center text-sm text-gray-600">
                                <svg className="w-4 h-4 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                </svg>
                                {searchData.city}
                            </div>
                        </div>
                        <div className="container mx-auto flex items-center justify-between px-4 py-2 text-sm text-gray-600">
                            <div>
                                <span className="text-blue-600">Home</span> &gt; {searchData.city} /{" "}
                                {hotelDataFull && hotelDataFull.length > 0 && hotelDataFull.length} Hotels found

                                {searchData.selectedRatings.length > 0 && (
                                    <span className="ml-2 rounded bg-blue-100 px-2 py-1 text-xs text-blue-800">
                                        Ratings: {searchData.selectedRatings.join(", ")} stars
                                    </span>
                                )}
                            </div>

                            <div>
                                <select
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    className="ml-auto cursor-pointer rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 focus:border-[#1877F2] focus:outline-none sm:ml-0"
                                >
                                    {SORT_OPTIONS.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                    </>
                )}
            </header>


            {!showModifyForm && (
                <div className="container mx-auto px-4 py-6">
                    <div className="flex flex-col lg:flex-row gap-6">
                        {/* Filters Sidebar */}
                        <div className="lg:w-1/4">
                            <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6 max-h-[calc(100vh-2rem)] overflow-y-auto">
                                <h3 className="font-semibold text-lg mb-4 pb-2 border-b top-0 bg-white z-10">Select Filter</h3>

                                <div className="space-y-6">
                                    {/* Search Bar */}
                                    <div className="hotel-search-bar">
                                        <div className="w-full mx-auto">
                                            <div className="relative flex items-center">
                                                <div className="flex-1">
                                                    <input
                                                        type="text"
                                                        id="hotel-search-by-name"
                                                        onKeyUp={searchByHotel}
                                                        className="w-full px-4 py-3 pl-12 text-gray-700 bg-white border border-gray-300 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 hover:border-gray-400"
                                                        placeholder="Search for locality / hotel name"
                                                    />
                                                    {/* Search icon */}
                                                    <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                                                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Price Filter */}
                                    <div className="mb-6">
                                        <h4 className="font-medium mb-3">Price</h4>

                                        <div className="mb-2">
                                            <ReactRangeSliderInput value={priceRange} min={MinPriceRange} max={MaxPriceRange} onInput={priceRangeFilter} onClick={priceRangeFilter} id="range-slider-yellow" onChange={priceRangeFilter} />
                                        </div>

                                        {hotelData && hotelData?.length > 0 && <div className="flex justify-between items-center">
                                            <>
                                                <div>
                                                    {hotelData[0]?.Currency == 'INR' ? <CurFt currency={hotelData[0]?.Currency || 'INR'} price={Math.ceil(priceRange[0])} /> : <CurFt currency={hotelData[0]?.Currency || 'INR'} price={priceRange[0]} />}
                                                </div>

                                                <div>
                                                    {hotelData[0]?.Currency == 'INR' ? <CurFt currency={hotelData[0]?.Currency || 'INR'} price={Math.ceil(priceRange[1])} /> : <CurFt currency={hotelData[0]?.Currency || 'INR'} price={priceRange[1]} />}
                                                </div>
                                            </>
                                        </div>}
                                    </div>

                                    {/* Meal Filter */}
                                    <div>
                                        <h4 className="font-medium mb-3">Meal</h4>
                                        <div className="space-y-2">
                                            {filthotelMeal && filthotelMeal.map((meal) => (
                                                <div key={meal} className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id={`meal-${meal}`}
                                                        checked={selectedMeals.includes(meal)}
                                                        onChange={() => toggleMealOption(meal)}
                                                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                    />
                                                    <label htmlFor={`meal-${meal}`} className="ml-2 text-sm text-gray-700">
                                                        {meal}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className='mt-2'>
                                        <h4 className="font-medium mb-3">Star Ratings</h4>
                                        <div className="space-y-2">
                                            {searchData?.selectedRatings.length > 0 && searchData?.selectedRatings?.slice() // creates a copy so the original array isn't modified
                                                .sort((a, b) => a - b).map((stars) => (
                                                    <div key={stars} className="flex items-center">
                                                        <input type="checkbox" id={`stars-${stars}`} checked={selectedStars.includes(stars)} onChange={() => handleSelectedStars(stars)} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                                                        <label htmlFor={`stars-${stars}`} className="ml-2 flex text-sm text-gray-700">
                                                            {[...Array(stars)].map((_, i) => (
                                                                <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" >
                                                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                                                </svg>
                                                            ))}
                                                        </label>
                                                    </div>
                                                ))}

                                        </div>
                                    </div>

                                    <div className='mt-2'>
                                        <h4 className="font-medium mb-3">Property Type</h4>
                                        <div className="space-y-2">
                                            {filthotelProperty && Object.entries(filthotelProperty).map(([loc, count]) => (
                                                <div key={loc} className="flex items-center justify-between py-1">
                                                    <div className="flex items-center">
                                                        <input type="checkbox" id={`name-${count}`} checked={selectedHotelProType.includes(count)} onChange={() => handleselectedHotelProType(count)} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                        />
                                                        <label htmlFor={`name-${count}`} className="ml-2 text-sm text-gray-700">
                                                            {count}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className='mt-2'>
                                        <h4 className="font-medium mb-3">Hotel Location</h4>
                                        <div className="space-y-2">
                                            {filthotelLoc && Object.entries(filthotelLoc).map(([loc, count]) => (
                                                <div key={loc} className="flex items-center justify-between py-1">
                                                    <div className="flex items-center">
                                                        <input type="checkbox" id={`name-${loc}`} checked={selectedHotelLocation.includes(loc)} onChange={() => handleselectedHotelLocation(loc)} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                        />
                                                        <label htmlFor={`name-${loc}`} className="ml-2 text-sm text-gray-700">
                                                            {loc}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Results */}
                        <div className="lg:w-3/4">

                            {/* Hotel List */}
                            <div className="space-y-6">
                                {hotelData && hotelData.length > 0 && hotelData.slice(0, visibleCount).map((hotel) => (
                                    <div key={hotel.id} className="bg-white rounded-xl shadow-lg overflow-hidden mb-6 hover:shadow-2xl transition-shadow duration-300">
                                        <div className="flex flex-col md:flex-row">
                                            {/* Hotel Image */}
                                            {/* <div className="md:w-1/4 bg-gray-200 h-56 flex items-center justify-center overflow-hidden rounded-t-xl md:rounded-l-xl md:rounded-tr-none">
                                                {hotel?.img?.length > 0 ? (
                                                    <img src={hotel?.img?.[0]?.tns} alt={hotel?.name || "Hotel"} className="object-cover w-full h-full transition-transform duration-500 hover:scale-105" onError={(e) => (e.target.src = "/noimagefound.jpeg")} />
                                                ) : (
                                                    <img src="/noimagefound.jpeg" alt={hotel?.name || "Hotel"} className="object-cover w-full h-full" />
                                                )}
                                            </div> */}
                                            <div className="md:w-1/4 bg-gray-200 h-56 flex items-center justify-center overflow-hidden rounded-t-xl md:rounded-l-xl md:rounded-tr-none">
                                                <img
                                                    src={hotel?.img?.[0]?.tns || "/noimagefound.jpeg"}
                                                    alt={hotel?.name || "Hotel"}
                                                    className="object-cover w-full h-full transition-transform duration-500 hover:scale-105"
                                                    onError={(e) => {
                                                        e.currentTarget.onerror = null;
                                                        e.currentTarget.src = "/noimagefound.jpeg";
                                                    }}
                                                />
                                            </div>
                                            {/* Hotel Details */}
                                            <div className="md:w-2/4 px-6 py-1 flex flex-col justify-between">
                                                <div>
                                                    <h3 className="text-xl font-semibold mb-2 text-gray-800">{hotel?.name}</h3>
                                                    <div className="flex items-center text-gray-600 text-sm mb-3">
                                                        <svg className="w-4 h-4 mr-1 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                        </svg>
                                                        {hotel.loc}
                                                        <br />
                                                    </div>
                                                    {hotel.ad && hotel.ad.adr && hotel.ad.adr} {hotel.ad && hotel.ad.adr2 && hotel.ad.adr2} {hotel.ad && hotel.ad.postalCode && hotel.ad.postalCode}
                                                    <div className="mb-3 gap-2 flex flex-wrap text-xs mb-2"><StarRating rating={hotel.rt} />
                                                        <span className="">{hotel.MealPlan}</span>
                                                    </div>

                                                    <div className="flex flex-wrap gap-1 text-xs text-gray-500 mb-2">
                                                        {hotel.pops[0].freeCancellation && hotel.pops[0].freeCanceltill && (
                                                            <span className="bg-green-600 text-white px-2 py-1 rounded-full">{hotel.pops[0].freeCanceltill}</span>
                                                        )}
                                                        {hotel.NoOfRoom > 0 && hotel.pt === 'Homestay' && (
                                                            <span className="bg-gray-100 px-2 py-1 rounded-full">{hotel.NoOfRoom} Bedroom(s)</span>
                                                        )}
                                                        {hotel.BedType !== "" && hotel.TotalBed > 0 && hotel.pt === 'Homestay' && (
                                                            <span className="bg-gray-100 px-2 py-1 rounded-full">{hotel.TotalBed} {hotel.BedType?.join(", ")} Bed(s)</span>
                                                        )}
                                                        {hotel.totalBathroom > 0 && hotel.pt === 'Homestay' && (
                                                            <span className="bg-gray-100 px-2 py-1 rounded-full">{hotel.totalBathroom} Bathroom(s)</span>
                                                        )}
                                                    </div>
                                                    <div className="flex flex-wrap gap-1 text-xs text-gray-500 mb-2">
                                                        {hotel.facilities.length > 0 && (
                                                            <div className="mt-3 flex flex-wrap gap-1.5">
                                                                {hotel.facilities.map((f) => (
                                                                    <span
                                                                        key={f.id ?? f.name}
                                                                        className="rounded-full bg-slate-50 px-2.5 py-1 text-[11px] font-medium text-slate-500"
                                                                    >
                                                                        {f.name}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* )} */}
                                                </div>
                                            </div>
                                            {/* Price & Action */}
                                            <div className="md:w-1/4 p-6 border-t md:border-t-0 md:border-l border-gray-100 flex flex-col justify-between rounded-b-xl md:rounded-r-xl">
                                                <div className="text-right">
                                                    <div className="text-2xl font-bold text-red-600">{hotel.symbol} {hotel.pops[0].HotelRoomPrice.toLocaleString()}</div>
                                                    <div className="text-sm text-gray-500 mt-1">
                                                        {hotel.pt === 'Homestay' ? (
                                                            <>For {hotel.nights} nights</>
                                                        ) : (
                                                            <>
                                                                {searchData.totalAdults + searchData.totalChildren} Guests · {searchData.rooms.length} Rooms
                                                            </>
                                                        )}

                                                    </div>
                                                </div>
                                                <button className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded text-sm font-medium transition-colors" onClick={() => handleviewRoom(hotel)}>{hotel.pt === 'Homestay' ? 'View Details' : 'View Room'}</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {isLoadingMore && (
                                    <div className="flex justify-center py-4">
                                        <div className="text-blue-600">Loading more hotels...</div>
                                    </div>
                                )}

                                {/* End of results message */}
                                {visibleCount >= hotelDataFull.length && hotelDataFull.length > 0 && (
                                    <div className="text-center py-4 text-gray-500">
                                        All hotels loaded
                                    </div>
                                )}

                            </div>

                            <div className="flex justify-center mt-8 text-sm text-gray-600">
                                Showing {Math.min(visibleCount, hotelData.length)} of {hotelDataFull.length} hotels
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HotelSearchResults;